export default function StarIcon(props) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 34.5L15.6562 39.5625C14.1562 40.5 12.2812 39.0938 12.75 37.4062L14.9062 27.9375L7.59375 21.5625C6.28125 20.4375 6.9375 18.1875 8.71875 18.0938L18.375 17.25L22.125 8.34375C22.875 6.75 25.125 6.75 25.875 8.34375L29.625 17.25L39.2812 18.0938C41.0625 18.2812 41.7188 20.4375 40.4062 21.5625L33.0938 27.9375L35.25 37.4062C35.7188 39.0938 33.8438 40.5 32.3438 39.5625L24 34.5Z"
        fill="#FFB800"
      />
    </svg>
  );
}
